﻿export const LEGEND_INITIALIZED = 'legendInitialized';
export const LEGEND_LAYER_RECREATED = 'legendLayerRecreated';
export const LEGEND_VISIBILITY_CHANGED = 'legendVisibilityChanged';
export const LAYER_OPACITY_CHANGED = 'layerOpacityChanged';
export const LAYER_VISIBILITY_CHANGED = 'layerVisibilityChanged';
export const LAYER_CLASSIFICATION_VISIBILITY_CHANGED = 'layerClassificationVisibilityChanged';
export const LAYER_SELECTABILITY_CHANGED = 'layerSelectabilityChanged';
export const LAYER_STYLE_CHANGED = 'layerStyleChanged';
export const LAYER_ANALYSIS_ADDED = 'analysisAdded';
export const LAYER_STYLE_MODIFIED = 'layerStyleModified';
export const LAYER_ORDER_CHANGED = 'layerOrderChanged';
export const LAYER_REMOVED = 'layerRemoved';
export const LAYER_ADDED = 'layerAdded';
export const TIMELINE_VISIBILITY_CHANGED = 'timelineVisibilityChanged';
export const LAYER_FIT = 'layerFit';
export const LAYER_EDITED = 'layerEdited';
export const MAP_POINTER_MOVE = 'mapPointerMove';
export const MAP_POINTER_CLICK = 'mapPointerClick';
export const MAP_POST_COMPOSE = 'mapPostCompose';
export const MAP_MOVE_END = 'mapMoveEnd';
export const MAP_LOADED = 'mapLoaded';
export const CLEAR_TEMPORARY_FEATURES = 'clearTemporaryFeatures';
export const FINISH_GEOMETRY = 'finishGeometry';
export const UNDO_VERTEX = 'undoVertex';
export const CONTOUR_SNAP_ON = 'contourSnapOn';
export const CONTOUR_SNAP_OFF = 'contourSnapOff';

export const TEMPORARY_LAYER_SELECTION_CHANGED = 'temporaryLayerSelectionChanged';
export const LAYER_SELECTION_CLEARED = 'layerSelectionCleared';
export const FEATURE_EDIT_STARTED = 'featureEditStarted';
export const FEATURE_MOVE_STARTED = 'featureMoveStarted';
export const FEATURE_MODIFIED = 'featureModified';
export const FEATURE_INSERTED = 'featureInserted';
export const FEATURE_EDITOR_STARTED = 'featureEditorStarted';
export const FEATURE_EDITOR_CANCELED = 'featureEditorCanceled';
export const FEATURES_MODIFIED = 'featuresModified';
export const FEATURE_REMOVED = 'featureRemoved';
export const FEATURES_CHANGED = 'featureChanged';
export const SCALE_CHANGED = 'scaleChanged';
export const GEOLOCATION_ERROR = 'geolocationError';
export const CURRENT_LOCATION_VISIBLITY_CHANGED = 'currentLocationVisibilityChanged';

export const USER_INTERACTION_STARTED = 'userInteractionStarted';
export const SWIPE_CHANGED = 'swipeChanged';

export const FEATURE_SELECTION_CHANGED = 'featureSelectionChanged';
export const MAP_MULTIPLE_LAYER_SELECTION = 'mapMultipleLayerSelection';
export const RIGHT_CLICK = 'rightClick';
export const FEATURE_TOOLS_VISIBILITY_CHANGED = 'featureToolsVisibilityChanged';
export const FEATURE_TOOLS_EDIT_STARTED = 'featureToolsEditStarted';
export const FEATURE_TOOLS_EDIT_ENDED = 'featureToolsEditEnded';
export const FEATURE_TOOLS_COPY_STARTED = 'featureToolsCopyStarted';
export const FEATURE_TOOLS_COPY_ENDED = 'featureToolsCopyEnded';
export const CLEAR_MULTIPLE_SELECTION = 'clearMultipleSelection';

export const DRAW_TOOLBAR_VISIBLE = 'drawToolbarVisible';
export const DRAW_TOOLBAR_HIDDEN = 'drawToolbarHidden';

export const START_SNAP = 'startSnap';
export const STOP_SNAP = 'stopSnap';
export const GENERAL_ACTION_SHOW = 'generalActionShow';